"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PADRIGHT = void 0;
const tab_1 = require("../../../tab");
exports.PADRIGHT = {
    description: 'Pad string with a character on the right side',
    arg_names: ['string_to_pad', 'str_length', 'char_to_pad'],
    args_def: [
        {
            types: ['string', 'number'],
            required: true,
        },
        {
            types: ['number'],
            required: true,
            variadic: false,
        },
        {
            types: ['string'],
            required: true,
            variadic: false,
        },
    ],
    args_description: ['original string', 'final string length', 'char to pad'],
    return_type: tab_1.ColumnType.STRING,
};
